export default __webpack_public_path__ + "static/media/Group 626068 1.9e1b3fa9.svg";